module.exports = __webpack_public_path__ + "static/media/chat-icon.cd2c4c62.svg";